import { render, staticRenderFns } from "./_NotifContentShared.vue?vue&type=template&id=60011760&scoped=true&"
import script from "./_NotifContentShared.vue?vue&type=script&lang=js&"
export * from "./_NotifContentShared.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60011760",
  null
  
)

export default component.exports